import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "cy-data": "error",
    class: _normalizeClass([_ctx.error ? '' : 'hidden', 'error']),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteError && _ctx.deleteError(...args)))
  }, _toDisplayString(_ctx.error), 3))
}